import { ReactComponent as InfoIcon } from "@king-ict/eupisi-ui/components/Icon/Info.svg";
import { ReactComponent as InfoIconSmall } from "@king-ict/eupisi-ui/components/Icon/InfoSmall.svg";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import styles from "./InfoPanel.module.scss";

export interface InfoPanelProps {
  children?: any;
  color: "primary" | "success" | "danger" | "warning";
  className?: string;
  fullWidth?: boolean;
}

export const InfoPanel = ({
  children,
  color,
  className,
  fullWidth = false,
}: InfoPanelProps) => {
  const { t } = useTranslation();
  const getIcon = () => {
    return fullWidth ? (
      <InfoIcon aria-label={t("accessibility.infoIcon")} />
    ) : (
      <InfoIconSmall aria-label={t("accessibility.infoIcon")} />
    );
  };

  return (
    <div className={fullWidth ? styles.fullWidth : styles.autoWidth}>
      <Alert
        variant={color}
        className={`${styles.infoPanel} ${className ?? ""}`}
      >
        <div className={styles.icon}>{getIcon()}</div>
        <div className={styles.message}>{children}</div>
      </Alert>
    </div>
  );
};
